module.exports = __webpack_public_path__ + "assets/img/block-right-bb86c4fe.png";